<template>
  <md-card>
    <md-card-content class="md-layout invoice-item-container">
      <div class="md-layout offer-link-chip">
        <div v-if="item.offerId">
          <a :href="`files?filter=confirmed&id=${item.offerId}`">
            <md-button class="md-sm md-round">
              <md-icon> link </md-icon>
              {{ item.offerId }}
            </md-button>
          </a>
          <md-button
            class="md-sm md-round md-danger link-off-btn"
            @click="item.offerId = null"
          >
            <md-icon> link_off </md-icon>
          </md-button>
        </div>

        <div v-else>
          <md-button class="md-sm md-round link-off-btn" disabled>
            <md-icon> link_off </md-icon>
          </md-button>
        </div>

        <md-button
          v-if="$parent.$parent.items.length > 1"
          @click="deleteItem"
          class="md-just-icon md-danger md-round close-button"
        >
          <md-icon>delete</md-icon>
        </md-button>
      </div>

      <md-field class="md-layout-item md-size-5">
        <p>
          {{ index }}
        </p>
      </md-field>
      <ValidationProviderExtended
        :name="`Naziv stavke${index}`"
        rules="required|between:2,50"
        className="md-layout-item md-size-45"
      >
        <label> Naziv stavke </label>
        <md-input type="text" v-model="item.name"> </md-input>
      </ValidationProviderExtended>
      <drop-down
        ref="nameDropdown"
        direction="down"
        multiLevel
        @close-dropdown="menuIsOpen = false"
        @open-dropdown="menuIsOpen = true"
      >
        <md-button
          class="md-just-icon switch-button"
          :class="menuIsOpen || 'md-info'"
        >
          <md-icon>
            {{ menuIsOpen ? 'maximize' : item.comment ? 'menu' : 'remove' }}
          </md-icon>
        </md-button>
        <ul class="dropdown-menu dropdown-menu-right item-name-container">
          <md-field>
            <label> Opis stavke </label>
            <md-textarea
              class="item-name-textarea"
              type="text"
              v-model="item.comment"
            >
            </md-textarea>
          </md-field>
        </ul>
      </drop-down>

      <md-field class="md-layout-item md-size-25">
        <label> Količina </label>
        <md-input
          type="number"
          v-model="item.amount"
          @change="onChangeAmount"
          step="0.1"
        >
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-25">
        <label> Jedinica mjere </label>
        <md-select v-model="item.unitId">
          <md-option v-for="(unit, id) in itemUnits" :key="id" :value="id">
            {{ unit }}
          </md-option>
        </md-select>
      </md-field>

      <InvoiceItemPriceField
        class="md-layout-item md-size-25"
        label="Jedinična cijena €"
        v-model="item.unitPrice"
        @change="onChangeUnitPrice"
      />

      <InvoiceItemPriceField
        v-if="showPercentage"
        class="md-layout-item md-size-25"
        label="Rabat (%)"
        v-model="item.rebatePercentage"
        @change="onChangePrice('rebatePercentage')"
        step="0.1"
      />

      <InvoiceItemPriceField
        v-else
        class="md-layout-item md-size-25"
        label="Jedinična sa rabatom €"
        v-model="item.unitDiscountedPrice"
        @change="onChangePrice('unitDiscountedPrice')"
      />

      <md-button
        class="md-just-icon md-round switch-button"
        @click="showPercentage = !showPercentage"
      >
        <md-icon> reply_all </md-icon>
      </md-button>

      <InvoiceItemPriceField
        class="md-layout-item md-size-25"
        label="Cijena bez PDV-a €"
        step="0.01"
        v-model="item.totalPriceWOVat"
        @change="onChangePrice('totalPriceWOVat')"
      />

      <InvoiceItemPriceField
        class="md-layout-item md-size-25"
        label="Cijena sa PDV-om €"
        step="0.01"
        v-model="item.totalPrice"
        @change="onChangePrice('totalPrice')"
      />
    </md-card-content>
  </md-card>
</template>

<script>
import ValidationProviderExtended from '@/components/ValidationProviderExtended.vue';
import InvoiceItemPriceField from '@/components/InvoiceItemPriceField.vue';

export default {
  components: {
    ValidationProviderExtended,
    InvoiceItemPriceField,
  },
  props: {
    index: Number,
    item: Object,
    vat: String,
    itemUnits: Object,
  },

  data() {
    return {
      showPercentage: true,
      menuIsOpen: false,
    };
  },
  methods: {
    deleteItem() {
      this.$emit('delete-item', this.index);
    },
    clearFields(fieldsToClear) {
      for (const field of fieldsToClear) {
        this.item[field] = null;
      }
    },
    onChangeUnitPrice() {
      const fieldsToClear = [
        'totalPriceWOVat',
        'totalPrice',
        'rebatePercentage',
      ];

      if (!parseFloat(this.item.rebatePercentage)) {
        fieldsToClear.push('unitDiscountedPrice');
      }

      this.clearFields(fieldsToClear);

      this.$emit('update');
    },
    onChangePrice(changedField) {
      this.clearFields(
        [
          'unitDiscountedPrice',
          'totalPriceWOVat',
          'totalPrice',
          'rebatePercentage',
        ].filter(field => field !== changedField),
      );

      this.$emit('update');
    },
    onChangeAmount() {
      this.clearFields(['totalPriceWOVat', 'totalPrice']);

      this.$emit('update');
    },
  },
};
</script>

<style scoped>
.invoice-item-container {
  position: relative;
  padding-top: 2.5em;
  row-gap: 2em;
}
.switch-button {
  position: relative;
  height: 0.8em;
  left: -2.5em;
  top: -1em;
  margin-right: -1.8em;
}
.item-name-container {
  margin-top: -3rem;
  margin-right: -5.2rem;
  padding: 0 2em;
}
.md-textarea.item-name-textarea {
  width: 20em;
  min-height: 10em !important;
}
.offer-link-chip {
  position: absolute;

  justify-content: space-between;
  top: -0.7em;
  padding-right: 30px;
}
.link-off-btn {
  min-width: 1em;
  font-size: 0.7em;
}
</style>
